module.exports = __webpack_public_path__ + "static/media/document.92c9d145.png";